/**
 * Component: Blog categories
 * ------------------------------------------------------------------------------
 * Adds carousel to blog tags section.
 *
 * @namespace blogCategories
 */
import { values as breakpoints } from '../helpers/breakpoints';
import Carousel from './carousel';
/**
 * DOM selectors.
 */

const selectors = {
  carousel: '[js-blog-categories="carousel"]',
  cell: '[js-blog-categories="cell"]'
};
/**
 * Instance globals.
 */

let categoriesCarousel = {};
/**
 * Create a new example object.
 */

export default (() => {
  /**
   * Instance default settings.
   */
  const carouselSettings = {
    swiper: {
      cellSelector: selectors.cell,
      cellAlign: 'center',
      breakpoints: {
        [breakpoints.tiny]: {
          slidesPerView: 4.3,
          slidesPerGroup: 2,
          centerInsufficientSlides: false
        },
        [breakpoints.medium]: {
          slidesPerView: 8.75,
          slidesPerGroup: 2,
          centerInsufficientSlides: true
        },
        [breakpoints.large]: {
          slidesPerView: 10,
          slidesPerGroup: 2
        },
        [breakpoints.wide]: {
          slidesPerView: 15,
          slidesPerGroup: 4
        }
      },
      loop: false,
      centerInsufficientSlides: true
    }
  };
  /**
   * DOM node selectors.
   */

  const nodeSelectors = {
    container: document.querySelector(selectors.container),
    cells: document.querySelectorAll(selectors.cell)
  };

  function constructCarousel() {
    if (nodeSelectors.cells.length <= 4) {
      return;
    }

    categoriesCarousel = Carousel(selectors.carousel, carouselSettings);
    categoriesCarousel.init();
  }
  /**
   * Initialise component.
   */


  function init() {
    constructCarousel();
  }
  /**
   * Expose public interface.
   */


  return Object.freeze({
    init
  });
});